import { ChangeEvent } from 'react';
import IconButton from '@material-ui/core/IconButton';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import { ContainerImport, Input, Span } from './ButtonStyle';
import Grid from '../grid/GridComponent.component';

interface Props {
    onChange(event: ChangeEvent<HTMLInputElement>): void;
    disabled?: boolean;
    fileName?: string;
    required?: boolean;
}

export default function UploadButtons({ onChange, disabled, fileName }: Props) {

    return (
        <ContainerImport>
            <Grid justify="space-between" alignItems="center">
                <Span>{fileName}</Span>
                <Input
                    onChange={onChange}
                    accept="image/*"
                    id="icon-button-file"
                    type="file"
                    disabled={disabled}
                />
                <label htmlFor="icon-button-file">
                    <IconButton color="primary" aria-label="upload picture" component="span" disabled={disabled} style={{ marginTop: -1 }}>
                        <PhotoCamera />
                    </IconButton>
                </label>
            </Grid>
        </ContainerImport>
    );
}